import { useEffect, useRef, useState } from "react";

const languages = [
  { code: "hu", label: "Magyar", short: "HU" },
  { code: "en", label: "English", short: "EN" },
];

function LangDropdown({ lang, onChange, ariaLabel, variant = "light" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const current = languages.find((item) => item.code === lang) ?? languages[0];
  const variantClass = variant === "dark" ? " lang-dropdown-dark" : "";

  useEffect(() => {
    function handleClickOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  function selectLanguage(code) {
    onChange(code);
    setOpen(false);
  }

  return (
    <div
      className={`lang-dropdown${variantClass}${open ? " is-open" : ""}`}
      ref={rootRef}
    >
      <button
        type="button"
        className="lang-dropdown-trigger"
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="lang-dropdown-code">{current.short}</span>
        <span className="lang-dropdown-chevron" aria-hidden="true" />
      </button>

      {open && (
        <ul className="lang-dropdown-menu" role="listbox" aria-label={ariaLabel}>
          {languages.map((item) => (
            <li key={item.code} role="option" aria-selected={lang === item.code}>
              <button
                type="button"
                className={
                  lang === item.code
                    ? "lang-dropdown-option is-active"
                    : "lang-dropdown-option"
                }
                onClick={() => selectLanguage(item.code)}
              >
                <span className="lang-dropdown-option-code">{item.short}</span>
                <span className="lang-dropdown-option-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LangDropdown;
